/**
 * The line icons shared across status screens and buttons.
 *
 * Drawn at 24×24 on a 1.75 stroke to match Passport's set; the consuming
 * class (`.status__icon svg`, `.btn svg`) sizes them down. Kept here rather
 * than pulled from an icon package so the auth path ships no runtime
 * dependency for six glyphs.
 */
type IconProps = { className?: string }

function Line({ children, className }: IconProps & { children: React.ReactNode }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {children}
    </svg>
  )
}

export function BuildingIcon(props: IconProps) {
  return (
    <Line {...props}>
      <path d="M3 21h18" />
      <path d="M6 21V7a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v14" />
      <path d="M10 21v-4h4v4" />
      <path d="M10 9h.01" />
      <path d="M14 9h.01" />
      <path d="M10 13h.01" />
      <path d="M14 13h.01" />
    </Line>
  )
}

export function AlertCircleIcon(props: IconProps) {
  return (
    <Line {...props}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 9v4" />
      <path d="M12 17h.01" />
    </Line>
  )
}

export function AlertTriangleIcon(props: IconProps) {
  return (
    <Line {...props}>
      <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" />
      <path d="M12 9v4" />
      <path d="M12 17h.01" />
    </Line>
  )
}

export function CompassIcon(props: IconProps) {
  return (
    <Line {...props}>
      <circle cx="12" cy="12" r="9" />
      <path d="m15.5 8.5-2 5-5 2 2-5z" />
    </Line>
  )
}

export function WaveIcon(props: IconProps) {
  return (
    <Line {...props}>
      <circle cx="12" cy="12" r="9" />
      <path d="M8.5 14.5a4.5 4.5 0 0 0 7 0" />
      <path d="M9 9.5h.01" />
      <path d="M15 9.5h.01" />
    </Line>
  )
}
